import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { findLink } from '../../../../LinkyLinky';
import LearningCollectionsStore from '../../Store';
import CurrentCollectionStep from '../Edit/CurrentCollectionStep';
import LearningCollectionEditStore from '../Edit/Store';
import LearningCollectionReactions from '../Edit/Store/Reactions';
import withRouter from '../WithRouter';
import ShareableLinks from './ShareableLinks';

interface Props {
  params: { id: string };
  store: LearningCollectionsStore;
}

function ProgramAccess({ params, store }: Props) {
  const learningCollectionStore = useMemo(() => new LearningCollectionEditStore(store), [store]);

  useEffect(() => {
    learningCollectionStore.loadingForDeepLinks(params.id);
    learningCollectionStore.learningDesignsStore.loading(nothing());
  }, [learningCollectionStore, params.id]);

  return (
    <>
      <CurrentCollectionStep store={learningCollectionStore} />
      <LearningCollectionReactions store={learningCollectionStore} />
    </>
  );
}

// DVLP-7041: the server sends the Shareable Links link only to admins who can
// share collection courses. Everyone else keeps Program Access and its
// per-course invite.
function DeepLinks({ params, store }: Props) {
  return findLink('learning-collection-deep-links', currentUserStore.links)
    .map(() => <ShareableLinks id={params.id} />)
    .getOrElse(() => <ProgramAccess params={params} store={store} />);
}

export default observer(withRouter(DeepLinks));
